import { AlignmentType, Paragraph, TextRun, WidthType } from "docx"

export const barchartText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The below chart depicts the number of discovered vulnerabilities mapped to OWASP 2024 testing category.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})
export const OWASPText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 650, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "OWASP has rated the Top Ten Vulnerabilities found in Mobile applications worldwide. OWASP Mobile Top Ten Vulnerabilities details can be found at below link.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})
export const OWASPText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "https://owasp.org/www-project-top-ten/",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})